import React from 'react';
import { ClipLoader } from 'react-spinners';
import './FullScreenLoader.css';

const FullScreenLoader = ({ loading, message = "Loading..." }) => {
  if (!loading) return null;

  return (
    <div className="fullscreen-loader">
      <div className="fullscreen-loader-content">
        <div className="loader-logo">
          <img 
            src="/images/the-value-logo.png" 
            alt="The Value Finds Logo" 
            style={{
              maxWidth: "250px",
              width: "100%",
              marginBottom: "20px"
            }}
          />
        </div>
        <ClipLoader
          color="#5378f4"
          loading={loading}
          size={50}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        <p className="loader-message">{message}</p>
      </div>
    </div>
  );
};

export default FullScreenLoader;
